// extracted by mini-css-extract-plugin
export var boxItems = "_1l-1";
export var boxItemsLg = "_1l-2";
export var button = "_1l-7";
export var buttonLg = "_1l-8";
export var filterGroupBox = "_1l-0";
export var icon = "_1l-3";
export var iconSecondary = "_1l-6";
export var iconWrapper = "_1l-4";
export var iconWrapperLg = "_1l-5";